import type { ChildrenProps } from "../types";

export function ModalFooter({ children }: ChildrenProps) {
	return (
		<div className="flex flex-row justify-between items-center gap-4 border-color border-t w-full modal-padding">
			{children}
		</div>
	);
}
